module.exports = __webpack_public_path__ + "static/img/sy_fh.6604f27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/sy_fh.png
// module id = rcEr
// module chunks = 1